<template>
  <div
    class="sidebar-section h-full flex flex-column justify-content-between"
    :class="{ 'show-sidebar': store.getters.showSidebar }"
  >
    <div>
      <div v-for="(route, index) in routes" :key="index">
        <router-link
          :to="route.to"
          class="p-ripple link no-underline p-2 m-2 border-round"
          :class="[isCypress ? `custom-link-${route.to}` : '']"
          v-ripple
          @click="store.commit('setShowSidebar', false)"
        >
          <div class="content flex gap-2 align-items-center">
            <i :class="route.icon"></i>
            {{ route.title }}
          </div>
        </router-link>
      </div>
    </div>

    <Version />
  </div>

  <div
    class="sidebar-overlay"
    :class="{ 'show-overlay': store.getters.showSidebar }"
    @click="store.commit('setShowSidebar', !store.getters.showSidebar)"
  ></div>
</template>

<script setup>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useAuthorization } from "@sttedra_ui/framework";

import Version from "@/components/panels/Version.vue";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const { modelRef: authorizationModelRef } = useAuthorization();
const route = useRoute();
const store = useStore();
const mainRoutes = ref([
  // {
  //   name: "/informes",
  //   title: "Inicio",
  //   icon: "pi pi-home",
  //   layout: "web",
  // },
  {
    name: "Reports",
    title: "Informes",
    icon: "pi pi-book",
    layout: "web",
  },
  {
    name: "Users",
    title: "Usuarios",
    icon: "pi pi-user",
    layout: "admin",
  },
  {
    name: "UsersGroups",
    title: "Grupos de usuarios",
    icon: "pi pi-users",
    layout: "admin",
  },
  {
    name: "DataSources",
    title: "Fuentes de datos",
    icon: "pi pi-server",
    layout: "admin",
  },
  {
    name: "Categories",
    title: "Categorías",
    icon: "pi pi-bookmark",
    layout: "admin",
  },
  {
    name: "Workspaces",
    title: "Workspaces",
    icon: "pi pi-map",
    layout: "admin",
  },
]);
const routes = ref([]);
const layout = computed(() => store.getters.layout);
const isCypress = computed(() => window.Cypress);
// #endregion

// #region Functions
onMounted(() => {
  const interval = setInterval(() => {
    const userRol = authorizationModelRef.value.roles[0];

    clearInterval(interval);
    setRoutes(userRol);
  });

  setInterval(() => {
    setActiveLinks();
  });
});

// Set the routes in the store
function setRoutes(userRol) {
  routes.value = [];

  mainRoutes.value.forEach((route, index) => {
    let children = [];

    if (route.children) {
      route.children.forEach((child) => {
        if (
          route.layout == "web" ||
          (route.layout == layout.value && userRol == "Admin")
        ) {
          children.push({
            label: child.title,
            icon: child.icon,
            to: child.name,
            type: "item",
          });
        }
      });
    }

    if (
      route.layout == "web" ||
      (route.layout == layout.value && userRol == "Admin")
    ) {
      routes.value.push({
        key: index,
        title: route.title,
        label: route.title,
        icon: route.icon,
        to: route.name,
        children,
      });
    }
  });
}

function removeActiveLinks() {
  const activeLinks = document.querySelectorAll(".custom-link-active");

  if (activeLinks) {
    activeLinks.forEach((link) => {
      link.classList.remove("custom-link-active");
    });
  }
}

function setActiveLinks() {
  const activeLinks = document.querySelectorAll(".router-link-active");

  if (activeLinks) {
    activeLinks.forEach((link) => {
      let parent = link.closest("div[data-pc-section='content']");

      if (parent) {
        parent.classList.add("custom-link-active");
      }
    });
  }
}
// #endregion

// #region Effects, Hooks
watch(route, () => {
  removeActiveLinks();
});

watch(layout, () => {
  setRoutes(authorizationModelRef.value.roles[0]);
});
// #endregion

// #region Provide, Expose
// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.sidebar-section {
  transition: $transition;
  background-color: white;

  .link {
    transition: $transition;
    display: flex;
    align-items: center;
    color: #1e1e1e;

    .content {
      transition: $transition;
    }

    &:hover {
      background-color: $light-secondary;
    }

    &.router-link-active {
      background-color: $secondary;
    }
  }

  @media (min-width: $mobile-min-width) and (max-width: $mobile-max-width) {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: $sidebar-z-index;
    transform: translateX(-100%);
    border-top: 1px solid $dark-primary;

    &.show-sidebar {
      transform: translateX(0);
    }
  }

  @media (min-width: $tablet-min-width) and (max-width: $laptop-max-width) {
    .link {
      font-size: 0.8rem;
    }
  }
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: $sidebar-overlay-z-index;
  visibility: hidden;
  opacity: 0;
  transition: $transition;

  &.show-overlay {
    visibility: visible;
    opacity: 1;
  }
}
</style>
